/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class IpAddress extends RiskFactor {
    icon = 'map-marker';

    label = 'Ip Address';

    static getCondition({ipAddress}) {
        return !!ipAddress;
    }

    parse({ipAddress}) {
        this.ipAddress = ipAddress;
    }

    getResult() {
        return this.ipAddress;
    }
}
